import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../components/LanguageContext';
import Nav from '../components/Nav';
import Form from '../components/FormBlock';
import Footer from '../components/Footer';
import axios from 'axios';
import './page.css';

const ServicesPage = () => {
  const { language, translations } = useLanguage();
  const location = useLocation();
  const [isExpanded, setIsExpanded] = useState({
    finding_best_fit_tender: false,
    preparation_of_bids: false,
  });
  const [servicesImage, setServicesImage] = useState('');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    const fetchServicesImage = async () => {
      try {
        const serverBaseUrl = process.env.REACT_APP_SERVER_BASE_URL || 'http://localhost:5000';
        const res = await axios.get(`${serverBaseUrl}/api/services-image`);
        setServicesImage(res.data.imageUrl || '');
      } catch (error) {
        console.error('Помилка завантаження зображення для ServicesPage:', error);
      }
    };
    fetchServicesImage();
  }, []);

  const toggleExpand = (key) => {
    setIsExpanded((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const services = translations['servicesTranslations.json']?.services || {};

  const renderTextWithStyles = (text) => {
    if (!text) return null;
    const keywords = ['Education', 'Experience', 'Languages', 'Location'];
    return text.split('\n').map((line, index, array) => {
      const parts = line.split(new RegExp(`(${keywords.join('|')})`, 'g')).map((part, i) => {
        if (keywords.includes(part)) {
          return <span key={i} style={{ fontWeight: 700 }}>{part}</span>;
        }
        return part;
      });
      return (
        <React.Fragment key={index}>
          {parts}
          {index < array.length - 1 && <br />}
        </React.Fragment>
      );
    });
  };

  return (
    <div className="content_container">
      <Nav />
      <div className="container">
        <h1 className="services_header-title">{services.title?.[language]}</h1>
        <p className="services_descr-title">{renderTextWithStyles(services.header_description?.[language])}</p>
        <img src={servicesImage} alt="Services Header" className="services_image" />
        <div className="services_container">
          <div className="services_item">
            <p className="services_title">{services.items?.finding_best_fit_tender?.title?.[language]}</p>
            <div className="collapsible_container">
              <div className={`collapsible-text ${isExpanded.finding_best_fit_tender ? 'expanded' : ''}`}>
                <p className="services_descr">{renderTextWithStyles(services.items?.finding_best_fit_tender?.description?.[language])}</p>
              </div>
              <button className="toggle-button" onClick={() => toggleExpand('finding_best_fit_tender')}>
                {isExpanded.finding_best_fit_tender ? 'COLLAPSE' : 'MORE'}
              </button>
            </div>
          </div>
          <div className="services_item">
            <p className="services_title">{services.items?.preparation_of_bids?.title?.[language]}</p>
            <div className="collapsible_container">
              <div className={`collapsible-text ${isExpanded.preparation_of_bids ? 'expanded' : ''}`}>
                <p className="services_descr">{renderTextWithStyles(services.items?.preparation_of_bids?.description?.[language])}</p>
              </div>
              <button className="toggle-button" onClick={() => toggleExpand('preparation_of_bids')}>
                {isExpanded.preparation_of_bids ? 'COLLAPSE' : 'MORE'}
              </button>
            </div>
          </div>
          <div className="services_item">
            <p className="services_title">{services.items?.contract_award_support?.title?.[language]}</p>
            <p className="services_descr">{renderTextWithStyles(services.items?.contract_award_support?.description?.[language])}</p>
          </div>
          <div className="services_item">
            <p className="services_title">{services.items?.post_contract_support?.title?.[language]}</p>
            <p className="services_descr">{renderTextWithStyles(services.items?.post_contract_support?.description?.[language])}</p>
          </div>
          <div className="services_item">
            <p className="services_title">{services.items?.appeals_and_dispute_resolution?.title?.[language]}</p>
            <p className="services_descr">{renderTextWithStyles(services.items?.appeals_and_dispute_resolution?.description?.[language])}</p>
          </div>
          <div className="services_item">
            <p className="services_title">{services.items?.training?.title?.[language]}</p>
            <p className="services_descr">{renderTextWithStyles(services.items?.training?.description?.[language])}</p>
          </div>
          <div className="services_item">
            <p className="services_title">{services.items?.tender_alert_service?.title?.[language]}</p>
            <p className="services_descr">{renderTextWithStyles(services.items?.tender_alert_service?.description?.[language])}</p>
          </div>
        </div>
        <Form />
        <Footer />
      </div>
    </div>
  );
};

export default ServicesPage;